import { http } from '@admin-base/core'

const prefix = '/'
// const filePrefix = '/base/'
const filePrefix = '/'

// 电子书列表
const ebookList = data => {
    return http.post(prefix + 'api/resource/ebook/pageList', data)
}

// 新增电子书
const addEbook = data => {
    return http.post(prefix + 'api/resource/ebook/add', data)
}

// 编辑电子书
const editEbook = data => {
    return http.post(prefix + 'api/resource/ebook/edit', data)
}

// 删除电子书
const deleteEbook = data => {
    return http.post(prefix + `api/resource/ebook/delete/${data}`)
}

// 上/下架电子书
const changeStatus = data => {
    return http.post(prefix + 'api/resource/ebook/changeStatus', data)
}

// 电子书详情
const ebookDetail = data => {
    return http.get(prefix + `api/resource/ebook/info/${data}`)
}

// 申请列表
const applyList = data => {
    return http.post(prefix + 'api/resource/ebook/apply/List', data)
}

// 拒绝列表
const rejectList = data => {
    return http.post(prefix + 'api/resource/ebook/reject/List', data)
}

// 审核电子书
const ebookReview = data => {
    return http.post(prefix + 'api/resource/ebook/review', data)
}

// 目录列表
const catalogueList = data => {
    return http.get(prefix + `api/resource/ebook/catalogue?id=${data}`)
}

// 新增目录
const catalogueAdd = data => {
    return http.post(prefix + 'api/resource/ebook/catalogue/add', data)
}

// 编辑目录
const catalogueEdit = data => {
    return http.post(prefix + 'api/resource/ebook/catalogue/edit', data)
}

// 删除目录
const catalogueDelete = data => {
    return http.post(prefix + `api/resource/ebook/catalogue/delete/${data}`)
}

// 目录详情
const catalogueDetail = data => {
    return http.get(prefix + `api/resource/ebook/catalogue/info/${data}`)
}

// 上传获取电子书封面
const getCover = data => {
    return http.post(filePrefix + 'file/v1/pdf/to/png', data)
}

// 上传获取电子书全部图片
const getPictures = data => {
    return http.post(filePrefix + 'file/v1/pdf2Image', data)
}

export {
    ebookList,
    addEbook,
    editEbook,
    deleteEbook,
    changeStatus,
    ebookDetail,
    applyList,
    rejectList,
    ebookReview,
    catalogueList,
    catalogueAdd,
    catalogueEdit,
    catalogueDelete,
    catalogueDetail,
    getCover,
    getPictures
}
